import { useMutation } from '@tanstack/react-query';
import { addParticipant } from '../../services/chats';

interface Options {
  onSuccess?: (data: Awaited<ReturnType<typeof addParticipant>>) => void;
  onError?: (error: Error) => void;
}

function useAddParticipant({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: ({
      conversationId,
      userId,
    }: {
      conversationId: string;
      userId: string;
    }) => addParticipant(conversationId, userId),
    onSuccess,
    onError,
  });
}

export default useAddParticipant;
